module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }